import type { Locale } from "@/config/locale";

/**
 * Unicode regional indicator sequence (ISO 3166-1 alpha-2), e.g. DE → 🇩🇪.
 * EU uses the EU flag emoji sequence.
 */
export function iso2ToFlagEmoji(code: string): string {
	const upper = code.toUpperCase();
	if (upper === "EU") return "\u{1F1EA}\u{1F1FA}";
	if (upper.length !== 2) return "";
	const base = 0x1f1e6 - 0x41;
	return String.fromCodePoint(upper.charCodeAt(0) + base, upper.charCodeAt(1) + base);
}

/** Primary country/region flag for storefront language (en → US per en-US locale). */
const localeToIso2: Record<Locale, string> = {
	en: "US",
	de: "DE",
	it: "IT",
	es: "ES",
	"es-mx": "MX",
	fr: "FR",
	nl: "NL",
	pt: "PT",
	"pt-br": "BR",
	pl: "PL",
	sv: "SE",
	da: "DK",
	el: "GR",
	cs: "CZ",
	fi: "FI",
	ro: "RO",
	hu: "HU",
	sk: "SK",
	tr: "TR",
	nb: "NO",
	bg: "BG",
	hr: "HR",
	sl: "SI",
	sr: "RS",
	bs: "BA",
	mk: "MK",
	lt: "LT",
	lv: "LV",
	et: "EE",
};

export function localeToFlagIso(locale: Locale): string {
	return localeToIso2[locale];
}

export function channelSlugToFlagIso(slug: string): "EU" | "US" {
	const s = slug.toLowerCase();
	if (s.includes("us")) return "US";
	return "EU";
}
